export enum GameCategories {
  FREE_TO_PLAY = 'Free to Play',
  ONLINE_GAMES = 'Online Games',
  MULTIPLAYER_ONLINE = 'Multiplayer Online Games',
  UNLIMITED_PLAY = 'wild Unlimited Play',
  ON_SALE = 'On Sale',
  MOST_POPULAR_GAMES = 'Most Popular Games',
}
